/**
 * Qui peut quoi sur les équipes — miroir EXACT des gardes de
 * backend/src/routes/groups.js, écrit une fois et importé par les écrans.
 *
 * Hors d'un composant React, exprès : un fichier d'écran qui exporte aussi des
 * constantes perd le rechargement à chaud, et une règle qui doit refléter le
 * serveur n'a rien à faire au milieu du JSX.
 */
export const DROITS_VOIR_EQUIPES    = ['groups.read.all', 'groups.update.all', 'groups.create.all', 'users.create.all', 'users.read.all', 'users.update.all'];
export const DROITS_MODIFIER_EQUIPE = ['groups.update.all', 'users.create.all'];
export const DROITS_CREER_EQUIPE    = ['groups.create.all', 'users.create.all'];

// Droits qui CHANGENT les équipes à l'écran (créer / modifier), sans droit sur les
// comptes. Eux seuls ouvrent la page Utilisateurs sur l'onglet Groupes : lire les
// groupes (coordinateurs) ou les comptes (finance) n'en a pas besoin. Supprimer
// n'a pas de bouton dans l'onglet : il n'ouvre rien. (Inclus dans DROITS_VOIR_EQUIPES.)
export const DROITS_GERER_EQUIPES  = ['groups.create.all', 'groups.update.all'];

// Régler les heures sup. d'une équipe (plafond, seuil…) — miroir de DROITS_REGLER_HS
// (backend/src/routes/groups.js). Sans eux, l'onglet est en lecture seule.
export const DROITS_REGLER_HS_EQUIPE = ['overtime.create.all', 'users.create.all'];
